const FILL = ".js-btn-hover-fill";
const EXPANDED = "is-btn-hover-expanded";

export const btnHover = () => {
  // SP 等のタッチ端末（hoverなし/ポインタ粗い）では擬似hoverが発火することがあるので無効化
  const canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  if (!canHover) return;

  const buttons = document.querySelectorAll(".js-btn-hover");

  buttons.forEach((btn) => {
    const fill = btn.querySelector(FILL);
    if (!fill) return;

    let onLeaveEnd = null;

    const setFillPosition = (clientX, clientY) => {
      const anchor = fill.offsetParent || btn;
      const rect = anchor.getBoundingClientRect();
      const cx = clientX - rect.left;
      const cy = clientY - rect.top;
      const w = fill.offsetWidth;
      const h = fill.offsetHeight;
      fill.style.left = `${cx - w / 2}px`;
      fill.style.top = `${cy - h / 2}px`;
    };

    btn.addEventListener("mouseenter", (e) => {
      if (onLeaveEnd) {
        fill.removeEventListener("transitionend", onLeaveEnd);
        onLeaveEnd = null;
      }
      setFillPosition(e.clientX, e.clientY);
      void fill.offsetWidth;
      fill.classList.add(EXPANDED);
    });

    btn.addEventListener("mouseleave", (e) => {
      setFillPosition(e.clientX, e.clientY);
      void fill.offsetWidth;
      fill.classList.remove(EXPANDED);

      onLeaveEnd = (ev) => {
        if (ev.target !== fill || ev.propertyName !== "transform") return;
        fill.removeEventListener("transitionend", onLeaveEnd);
        onLeaveEnd = null;
        fill.style.removeProperty("left");
        fill.style.removeProperty("top");
      };
      fill.addEventListener("transitionend", onLeaveEnd);
    });
  });
};
